import styled from "styled-components";

import { Button as StyledButton } from "components/atoms/Button";
import { Input as StyledInput } from "components/atoms/Input";
import { Select as StyledSelect } from "components/atoms/Select";
import { colourScheme } from "utils/styling/colours";

export const FormContainer = styled.div`
    padding: 1rem;
    background-color: ${colourScheme.primaryDark};
    border-radius: 0.5rem;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.5);
    margin-top: 1.25rem;
`;

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
`;

export const FormGroup = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Label = styled.label`
    font-weight: bold;
    margin-bottom: 0.25rem;
    color: ${colourScheme.white};
`;

export const Input = styled(StyledInput)`
    padding: 0.5rem;
    border-radius: 0.25rem;
    border: 0.0625rem solid ${colourScheme.greyDark};
    background-color: ${colourScheme.primary};
    color: ${colourScheme.white};
    box-shadow: inset 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.5);
    transition: border-color 0.3s ease;

    &:focus {
        border-color: ${colourScheme.secondaryDark};
        outline: none;
    }
`;

export const Select = styled(StyledSelect)`
    padding: 0.5rem;
    border-radius: 0.25rem;
    border: 0.0625rem solid ${colourScheme.greyDark};
    background-color: ${colourScheme.primary};
    color: ${colourScheme.white};
    box-shadow: inset 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.5);
    transition: border-color 0.3s ease;

    &:focus {
        border-color: ${colourScheme.secondaryDark};
        outline: none;
    }
`;

export const Button = styled(StyledButton)`
    padding: 0.625rem 1rem;
    background-color: ${colourScheme.success};
    background-image: linear-gradient(
        to bottom,
        ${colourScheme.success},
        ${colourScheme.successDark}
    );
    color: ${colourScheme.fullWhite};
    border: none;
    border-radius: 0.25rem;
    cursor: pointer;
    transition:
        background-color 0.3s ease,
        box-shadow 0.3s ease;

    &:hover {
        background-color: ${colourScheme.successLight};
        box-shadow: 0 0.25rem 0.375rem rgba(0, 0, 0, 0.5);
    }

    &:focus {
        outline: none;
        box-shadow: 0 0 0 0.1875rem rgba(102, 153, 204, 0.5);
    }
`;

export const Error = styled.div`
    color: ${colourScheme.errorLight};
    margin-bottom: 0.625rem;
`;
